import React, { useEffect, useState } from "react";
import { Accordion, Row, Col } from 'react-bootstrap';
import Payment from "./Payment";
import Card from "./Card";
import Echeck from "./Echeck";
import PayPal from "./PayPal";


export default function Main({ merchantData, sendResult }) {

    const [isTransactionData, setIsTransactionData] = useState({});
    const [paymentMethods, setPaymentMethods] = useState([]);

    const [isLoader,setIsLoader] = useState(false);

    // Get transaction data from payment component:
    const getTransactionData = (data) => {
        setIsTransactionData(data);
    }

    //loader effect pass
    const getLoaderEffect = (data) =>{
        setIsLoader(data);
    }

    useEffect(() => {
        if (merchantData && merchantData.paymentMethods) {
            let methods = merchantData.paymentMethods.split(',').map(item => item.trim());
            setPaymentMethods(methods);
        }
    }, [merchantData])


    return (
        <>
            <div className="main">
                {/* Payment Component */}
                <Payment sendTransactionDataToParent={getTransactionData} loaderRunning={isLoader} />

                {/* title tag */}
                <Row>
                    <Col className="payment-title">
                        <h2>Payment Method</h2>
                    </Col>
                </Row>

                <div className="accordionMn">
                    <Accordion>
                        {/* Card Component */}
                        <Accordion.Item eventKey="0">
                            <Card 
                            merchantData={merchantData} 
                            transactionData={isTransactionData} 
                            is3DSecure={paymentMethods && paymentMethods.length > 0 && paymentMethods.includes('3DS')}
                            sendResultToParent={sendResult}
                            sendLoaderToPayment={getLoaderEffect}
                            />
                        </Accordion.Item>

                        {/* Echeck Component */}
                        {paymentMethods && paymentMethods.length > 0 && paymentMethods.includes('ACH') && <Accordion.Item eventKey="1">
                            <Echeck merchantData={merchantData} transactionData={isTransactionData} sendResultToParent={sendResult} />
                        </Accordion.Item>}

                        {/* Pay-pal Component */}
                        {/* <Accordion.Item eventKey="2">
                            <PayPal />
                        </Accordion.Item> */}
                    </Accordion>
                </div>
            </div>
        </>
    );
}

